<template>
    <div>
        <div >
            <el-form  :model="ecxForm" :rules="actrules" ref="ecxForm" label-width="150px" class="demo-ruleForm"  >
                <el-form-item label="活动编号" prop="actId">
                    <el-input v-model="ecxForm.actId" placeholder="活动编号" style="width: 60%;" disabled></el-input>
                </el-form-item>

                <el-form-item label="提货码名称" prop="excodeName">
                    <el-input v-model="ecxForm.excodeName" placeholder="提货码信息名称" style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="提货码数量" prop="count" >
                    <el-input v-model="ecxForm.count" placeholder="提货码数量" style="width: 30%;" disabled></el-input>
                </el-form-item>

                <el-form-item label="商品名称" v-for="(item,index) in productList" v-if="productList.length>0">
                    <el-input :value="item.name" disabled="disabled" style="width: 30%;"></el-input>
                    <el-button  @click="delProductInfo(index)">删除</el-button>
                </el-form-item>

                <el-form-item label="提货码信息类型" prop="excodeType">
                    <el-select v-model="ecxForm.excodeType" placeholder="提货码信息类型" @change="showFile()" disabled>
                        <el-option value="0" label="系统生成">系统生成</el-option>
                        <el-option value="1" label="预生成">预生成</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提货码商品信息" prop="product">
                    <el-select v-model="prodindex" placeholder="提货码商品信息">
                        <el-option
                                v-for="(item,index) in products"
                                :label="item.Data.Name"
                                :value="index"
                        >
                        </el-option>
                    </el-select>
                    <el-button  @click="setProductInfo()">添加</el-button>
                </el-form-item>

                <el-form-item label="出货类型" prop="productType">
                    <el-select v-model="ecxForm.productType" placeholder="出货类型">
                        <el-option value="All" label="全部出货">全部出货</el-option>
                        <el-option value="Ran" label="随机一件">随机一件</el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="提货码备注" prop="remark">
                    <el-input v-model="ecxForm.remark" placeholder="提货码备注" style="width: 30%;"></el-input>
                </el-form-item>

                <!--<el-form-item label="过期时间" prop="expDate">
                  <el-date-picker
                    v-model="ecxForm.expDate"
                    type="datetime"

                    placeholder="选择日期"
                    @change="getStartDate"
                  >
                  </el-date-picker>
                </el-form-item>-->

                <el-form-item label="提货码刷新周期" prop="isExp" >
                    <el-select v-model="ecxForm.isExp" placeholder="提货码刷新周期" @change="isExpType()">
                        <el-option value="0" label="不刷新">不刷新</el-option>
                        <el-option value="1" label="刷新">刷新</el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="提货码刷新时长(秒)" prop="expSecond" v-show="isexpSecond">
                    <el-input  v-model="ecxForm.expSecond" placeholder="提货码刷新时长" style="width: 30%;"></el-input>
                </el-form-item>

                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="ecxForm.status" @change="radioStatus">
                        <el-radio label="1" value="1">启用</el-radio>
                        <el-radio label="0" value="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary"  @click="submitForm('ecxForm')" id="primary" :disabled="isorgsubmit">确 定</el-button>
                    <el-button @click="resetForm('ecxForm')">重 置</el-button>
                </el-form-item>

            </el-form>

        </div>
    </div>
</template>
<script>
    import moment  from 'moment'
//    import { product, productUpdate, categoryProduct } from '@/assets/api.js'
    export  default{
        data(){
            var validateExcodeType = (rule, value, callback) => {

            };
            return{
                url:this.requetCodeHost+"/exManager/updateExCode",
                pushURL: this.productURL+"/vueFeign/getProductPutaway",
                isorno:true,
                isorgsubmit:false,
                isexpSecond:false,
                resourceType:"",
                labelposition:"left",
                upload_data:{
                    type:this.apkUploadWay,
                    folder:"app"
                },
                prodindex:0,
                productList:[],
                ecxForm:{
                    excodeName:'',
                    actId:'',
                    product:[],
                    expDate:'',
                    remark:'',
                    count:'',
                    exlName:'',
                    status:'',
                    excodeType:'',
                    productType:'',
                    isExp:'',
                    expSecond:'',
                    fileList:[],
                    quantity:1
                },
                products:[],
                isorginit:'1',
                actrules: {
                    excodeName: [
                        { required: true, message: '请输入提货码名称', trigger: 'blur' },
                        /*{ validator: validateactName, trigger: 'blur' },*/
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' }
                    ],
                    status: [
                        { required: true, message: '请选择状态', trigger: 'blur' }
                    ],
                    /*excodeType: [
                      { required: true, message: '请选择类型', trigger: 'blur' },
                      { validator: validateExcodeType, trigger: 'blur' },
                    ],*/
                    count: [
                        { required: true, message: '请输入商品数量', trigger: 'change' }
                    ],
                    status: [
                        { required: true, message: '请选择状态', trigger: 'change' }
                    ],
                    productType: [
                        { required: true, message: '请选择出货类型', trigger: 'change' }
                    ],
                    isExp: [
                        { required: true, message: '请选择提货码刷新周期', trigger: 'change' }
                    ]
                }
            }
        },
        created(){
            this.getProductList();
            this.initData();
        },
        methods:{
            setProductInfo(){
                if(this.products[this.prodindex].id==''||this.products[this.prodindex].id==undefined||this.products[this.prodindex].id==null){
                    this.$message({showClose: true,message: '请选择商品',type: 'error'});
                }else{
                    var productStr = this.products[this.prodindex].id+"&"+this.products[this.prodindex].Data.productName
                        +"&"+this.products[this.prodindex].Data.SKU+"&"+this.products[this.prodindex].Data.UPC+"&"
                        +this.products[this.prodindex].Data.price+"&"+this.ecxForm.quantity;
                    if(!this.in_array(productStr,this.ecxForm.product)){
                        this.ecxForm.product.push(productStr);
                        this.productList.push({"name":this.products[this.prodindex].Data.productName,"quantity":this.ecxForm.quantity});
                    }else{
                        this.$message({showClose: true,message: '重请勿添加重复商品',type: 'error'});
                    }
                }
            },
            delProductInfo(index){
                console.log(index);
                console.log("before1:"+this.ecxForm.product[index]);
                console.log("before2:"+this.productList[index]);
                this.ecxForm.product.splice(index, 1);
                this.productList.splice(index, 1);
                console.log("after1:"+this.ecxForm.product[index]);
                console.log("after2:"+this.productList[index]);
            },
            in_array(str, array) {
                for (var s = 0; s < array.length; s++) {
                    var thisEntry = array[s].toString();
                    if (thisEntry == str) {
                        return true;
                    }
                }
                return false;
            },
            getProductList(){
                var params = {kioskNo:this.ecxForm.kioskNo,tenantId:this.getcookie('storeId'),
                    productName:'',SKU:''};
                //异步请求
                this.$http.post(this.pushURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.products = response.body.Data.data
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })

            },
            submitForm(formName) {

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.ecxForm.isExp +"" === "1"){
                            if(this.ecxForm.expSecond <= 0){
                                this.$message({showClose: true,message: '请输入过期时间，最少大于一天',type: 'error'});
                                return false;
                            }
                        }
                        var params={excodeName:this.ecxForm.excodeName,products:this.ecxForm.product+"",expDate:this.ecxForm.expDate,remark:this.ecxForm.remark,status:this.ecxForm.status,id:this.$route.query.id,
                            productType:this.ecxForm.productType,isExp:this.ecxForm.isExp,expSecond:this.ecxForm.expSecond
                            ,Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'}
                        this.$http.post(this.url,params).then((response)=>{
                            var data=response.body;
                            if(data.res=="success"){
                                this.$message({showClose: true,message: '修改成功',type: 'success'});
                                this.$router.push({path:"excodeManager"})
                            }else{
                                this.$message({showClose: true,message: data.msg ,type: 'error'});
                            }
                        },()=>{
                            this.$message({showClose: true,message: '网络异常',type: 'error'});
                        })

                    }else{
                        console.log('error submit!!');
                        return false
                    }
                });
            },
            initData(){
                this.$http.post(this.requetCodeHost+"/exManager/findExcodeInfoById",{id:this.$route.query.id,Token: '01CDPN7ZV7GT2PV4KRYY9X1D6V'}).then((response)=>{
                    if(response.body.res == "success"){
                        var excodeInfo = response.body.data.excode;
                        this.ecxForm.excodeName = excodeInfo.excodeName;
                        this.ecxForm.expDate = this.getDate(excodeInfo.expTime);
                        this.ecxForm.remark = excodeInfo.remark;
                        this.ecxForm.count = excodeInfo.count;
                        this.ecxForm.status = excodeInfo.status;
                        this.ecxForm.excodeType = excodeInfo.excodeType;
                        this.ecxForm.product = response.body.data.products;
                        this.productList = response.body.data.showProds;

                        this.ecxForm.actId = this.$route.query.actId;
                        this.ecxForm.productType = excodeInfo.productType;
                        this.ecxForm.isExp = excodeInfo.isExp;
                        this.ecxForm.expSecond = excodeInfo.expSecond;
                        if (excodeInfo.isExp + "" == "1"){
                            this.isexpSecond=true;
                        }
                    }else {
                        this.$message({showClose: true,message: response.body.msg ,type: 'error'});
                    }

                },()=>{
                    this.$message({showClose: true,message: '网络异常',type: 'error'});
                })
            },
            getDate(time){
                var d = new Date(time);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString)
            },
            getStartDate(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.ecxForm.expDate=moment(d).format(formatString);
            },
            showFile(){
                this.isorno=false;
                var type = this.ecxForm.excodeType
                if (type === '0'){
                    this.isorno=true;
                }
            },
            radioStatus(vue){
                this.ecxForm.status = vue;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },
            isExpType(){
                this.isexpSecond=true;
                var type = this.ecxForm.isExp
                if (type === '0'){
                    this.ecxForm.expSecond = 0;
                    this.isexpSecond=false;
                }
            },
        }
    }
</script>
<style>
    .isable{
        display:none;
    }
    .demo-ruleForm{

        margin: 30px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// ExcodeModify.vue?575632e3